/** Job Brief v2 — shared stylesheet.  Mirrors AskStewie Landing tokens. */
export const jobBriefV2Styles = `
.jbv2-root {
  min-height: 100vh;
  background: #0d1438;
  color: #f5f5f5;
  font-family: -apple-system, BlinkMacSystemFont, "Inter", "Segoe UI", system-ui, sans-serif;
  padding-bottom: 96px;
  overflow-x: hidden;
}
.jbv2-root, .jbv2-root * { box-sizing: border-box; }

/* Header */
.jbv2-header {
  position: sticky; top: 0; z-index: 40;
  background: rgba(5,10,31,0.92);
  backdrop-filter: blur(14px);
  border-bottom: 1px solid rgba(148,163,184,0.14);
}
.jbv2-header-inner {
  max-width: 1200px; margin: 0 auto;
  padding: 12px 16px;
  display: flex; align-items: center; gap: 12px;
}
.jbv2-header-back {
  background: rgba(148,163,184,0.08); border: 1px solid rgba(148,163,184,0.20);
  color: #cbd5e1; border-radius: 10px; padding: 7px 10px;
  cursor: pointer; display: inline-flex; align-items: center; gap: 6px;
  font-size: 13px; font-weight: 600; font-family: inherit;
}
.jbv2-header-back:hover { background: rgba(148,163,184,0.16); color: #f1f5f9; }
.jbv2-header-logo {
  display: inline-flex; align-items: center; gap: 10px;
  color: #f1f5f9; font-weight: 800; font-size: 15px;
  background: transparent; border: none; padding: 4px 8px; border-radius: 10px;
  font-family: inherit; text-decoration: none;
}
.jbv2-header-logo:hover { background: rgba(255,255,255,0.05); }
.jbv2-header-logo img { width: 26px; height: 26px; border-radius: 8px; }
.jbv2-header-logo-text {
  background: linear-gradient(90deg, #67e8f9, #22d3ee);
  -webkit-background-clip: text; -webkit-text-fill-color: transparent;
  background-clip: text; color: transparent;
}
.jbv2-header-crumb { color: #94a3b8; font-weight: 500; font-size: 13px; }
.jbv2-header-spacer { flex: 1; }
.jbv2-header-user { color: #94a3b8; font-size: 13px; }
.jbv2-header-signout {
  padding: 7px 12px; border-radius: 10px;
  border: 1px solid rgba(220,38,38,0.35); color: #fca5a5;
  background: rgba(220,38,38,0.06);
  font-size: 13px; font-weight: 700; cursor: pointer; font-family: inherit;
  display: inline-flex; align-items: center;
}
.jbv2-header-signout:hover { background: rgba(220,38,38,0.14); }
@media (max-width: 640px) { .jbv2-header-user, .jbv2-header-crumb { display: none; } }

/* Main container */
.jbv2-main {
  max-width: 1200px; margin: 0 auto;
  padding: 20px 16px 24px;
  display: flex; flex-direction: column; gap: 20px;
}

/* Safety notice */
.jbv2-safety {
  display: flex; align-items: flex-start; gap: 10px;
  padding: 12px 14px;
  border-radius: 12px;
  background: rgba(250,204,21,0.10);
  border: 1px solid rgba(250,204,21,0.45);
  color: #fef08a;
  font-size: 13px; line-height: 1.5;
}
.jbv2-safety strong { color: #facc15; }
.jbv2-safety--dense { padding: 8px 12px; font-size: 12px; }

/* Hero */
.jbv2-hero {
  position: relative;
  padding: 22px 20px;
  border-radius: 20px;
  background: linear-gradient(135deg, rgba(15,27,70,0.88) 0%, rgba(5,10,31,0.92) 100%);
  border: 1px solid rgba(148,163,184,0.20);
  box-shadow: 0 20px 40px rgba(0,0,0,0.35);
  display: flex; gap: 20px; align-items: center; flex-wrap: wrap;
  overflow: hidden;
}
.jbv2-hero-content { flex: 1; min-width: 260px; position: relative; z-index: 1; }
.jbv2-hero-eyebrow {
  color: #facc15; font-size: 11px; font-weight: 800; letter-spacing: 0.22em; text-transform: uppercase;
}
.jbv2-hero-title {
  margin: 6px 0 0; font-size: clamp(24px, 4vw, 32px); font-weight: 800; color: #ffffff; letter-spacing: -0.01em;
}
.jbv2-hero-sub { margin: 10px 0 0; color: #cbd5e1; font-size: 14px; line-height: 1.5; }
.jbv2-hero-avatar {
  width: 96px; height: 96px; border-radius: 22px;
  background: rgba(0,0,0,0.25); border: 1px solid rgba(148,163,184,0.25);
  display: grid; place-items: center; overflow: hidden; flex-shrink: 0;
}
.jbv2-hero-avatar img { width: 100%; height: 100%; object-fit: cover; }
@media (max-width: 640px) { .jbv2-hero-avatar { width: 68px; height: 68px; border-radius: 18px; } }

/* Choice grid on the landing */
.jbv2-choice-grid {
  display: grid; grid-template-columns: 1fr; gap: 12px;
}
@media (min-width: 720px)  { .jbv2-choice-grid { grid-template-columns: repeat(2, 1fr); } }
@media (min-width: 1020px) { .jbv2-choice-grid { grid-template-columns: repeat(3, 1fr); } }
.jbv2-choice {
  display: flex; flex-direction: column; gap: 8px;
  min-height: 132px; padding: 16px;
  background: rgba(15,27,70,0.85);
  border: 1px solid rgba(148,163,184,0.22);
  border-radius: 14px;
  color: #f1f5f9; text-align: left;
  cursor: pointer; font-family: inherit;
  transition: transform 160ms, border-color 180ms, background 180ms;
}
.jbv2-choice:hover, .jbv2-choice:focus-visible {
  transform: translateY(-2px);
  border-color: rgba(250,204,21,0.55);
  background: rgba(15,27,70,0.95);
  outline: none;
}
.jbv2-choice--primary { border-color: rgba(103,232,249,0.55); background: linear-gradient(135deg, rgba(15,27,70,0.95), rgba(29,78,216,0.35)); }
.jbv2-choice-icon {
  width: 40px; height: 40px; border-radius: 10px;
  display: grid; place-items: center;
  color: var(--jb-c, #67e8f9);
  background: color-mix(in oklab, var(--jb-c, #67e8f9) 14%, transparent);
  border: 1px solid color-mix(in oklab, var(--jb-c, #67e8f9) 40%, transparent);
}
.jbv2-choice-title { font-size: 15px; font-weight: 800; }
.jbv2-choice-desc  { font-size: 12.5px; color: #cbd5e1; line-height: 1.45; }

/* Recent drafts strip */
.jbv2-recent { display: flex; flex-direction: column; gap: 8px; }
.jbv2-recent-item {
  display: flex; align-items: center; gap: 12px;
  padding: 12px 14px;
  background: rgba(15,27,70,0.65);
  border: 1px solid rgba(148,163,184,0.18);
  border-radius: 12px; color: #f1f5f9;
  cursor: pointer; font-family: inherit;
  transition: background 160ms, border-color 160ms;
}
.jbv2-recent-item:hover { background: rgba(15,27,70,0.90); border-color: rgba(250,204,21,0.35); }
.jbv2-recent-title { flex: 1; font-size: 14px; font-weight: 700; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.jbv2-recent-meta  { font-size: 12px; color: #94a3b8; }

/* Section header */
.jbv2-h { display: flex; flex-direction: column; gap: 4px; }
.jbv2-h-eyebrow { font-size: 11px; font-weight: 800; letter-spacing: 0.20em; text-transform: uppercase; color: #94a3b8; }
.jbv2-h-title   { margin: 0; font-size: 18px; font-weight: 800; color: #f1f5f9; }
.jbv2-h-underline { display: block; width: 40px; height: 3px; margin-top: 4px; border-radius: 3px; background: #facc15; }

/* Phase strip */
.jbv2-phase-strip {
  display: flex; gap: 8px; padding: 4px;
  background: rgba(15,27,70,0.55);
  border: 1px solid rgba(148,163,184,0.18);
  border-radius: 14px;
  overflow-x: auto;
}
.jbv2-phase-strip::-webkit-scrollbar { display: none; }
.jbv2-phase {
  flex: 1; min-width: 180px;
  display: flex; align-items: center; gap: 10px;
  padding: 10px 12px;
  background: transparent; border: 1px solid transparent;
  border-radius: 12px;
  cursor: pointer; font-family: inherit;
  color: #cbd5e1; text-align: left;
  transition: background 160ms, border-color 160ms;
}
.jbv2-phase:hover { background: rgba(148,163,184,0.06); }
.jbv2-phase--current { background: rgba(250,204,21,0.10); border-color: rgba(250,204,21,0.45); color: #fef08a; }
.jbv2-phase--done    { color: #86efac; }
.jbv2-phase-num {
  width: 28px; height: 28px; border-radius: 8px;
  display: grid; place-items: center;
  background: rgba(148,163,184,0.10);
  border: 1px solid rgba(148,163,184,0.28);
  flex-shrink: 0;
}
.jbv2-phase--current .jbv2-phase-num { background: rgba(250,204,21,0.20); border-color: #facc15; color: #facc15; }
.jbv2-phase--done    .jbv2-phase-num { background: rgba(34,197,94,0.15);  border-color: #22c55e; color: #22c55e; }
.jbv2-phase-body { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.jbv2-phase-label { font-size: 13px; font-weight: 800; }
.jbv2-phase-desc  { font-size: 11px; color: #94a3b8; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

/* Readiness cards */
.jbv2-scores { display: grid; grid-template-columns: 1fr; gap: 10px; }
@media (min-width: 720px) { .jbv2-scores { grid-template-columns: repeat(3, 1fr); } }
.jbv2-score-card {
  position: relative;
  display: flex; flex-direction: column; gap: 4px;
  padding: 14px;
  background: rgba(15,27,70,0.65);
  border: 1px solid rgba(148,163,184,0.20);
  border-left: 4px solid var(--jb-c, #67e8f9);
  border-radius: 14px;
}
.jbv2-score-icon {
  width: 28px; height: 28px; border-radius: 8px;
  color: var(--jb-c, #67e8f9);
  background: color-mix(in oklab, var(--jb-c, #67e8f9) 14%, transparent);
  border: 1px solid color-mix(in oklab, var(--jb-c, #67e8f9) 40%, transparent);
  display: grid; place-items: center;
}
.jbv2-score-label { font-size: 11px; font-weight: 800; letter-spacing: 0.10em; text-transform: uppercase; color: #94a3b8; }
.jbv2-score-value { font-size: 22px; font-weight: 800; color: #f1f5f9; letter-spacing: -0.02em; line-height: 1.2; }
.jbv2-score-bar   { display: block; height: 6px; margin-top: 6px; background: rgba(148,163,184,0.12); border-radius: 4px; overflow: hidden; }
.jbv2-score-bar > span { display: block; height: 100%; background: var(--jb-c, #67e8f9); transition: width 300ms; }
.jbv2-score--risk .jbv2-score-value { text-transform: capitalize; }

.jbv2-scores-detail {
  grid-column: 1 / -1;
  padding: 12px 14px;
  background: rgba(15,27,70,0.35);
  border: 1px solid rgba(148,163,184,0.14);
  border-radius: 12px;
  color: #cbd5e1; font-size: 12.5px;
}
.jbv2-scores-detail summary { cursor: pointer; font-weight: 700; color: #f1f5f9; }
.jbv2-scores-detail ul { margin: 6px 0 0 18px; }

/* Save state pill */
.jbv2-save-state {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 5px 10px; border-radius: 999px;
  background: rgba(15,27,70,0.65);
  border: 1px solid rgba(148,163,184,0.22);
  color: #94a3b8; font-size: 12px; font-weight: 700;
  white-space: nowrap; flex-shrink: 0;
}
.jbv2-save-state--dirty  { color: #facc15; border-color: rgba(250,204,21,0.35); background: rgba(250,204,21,0.08); }
.jbv2-save-state--saving { color: #60a5fa; border-color: rgba(96,165,250,0.35); background: rgba(96,165,250,0.08); }
.jbv2-save-state--saved  { color: #22c55e; border-color: rgba(34,197,94,0.35);  background: rgba(34,197,94,0.06); }
.jbv2-save-state--error  { color: #ef4444; border-color: rgba(239,68,68,0.40);  background: rgba(239,68,68,0.08); }
.jbv2-spin { animation: jbv2-spin-kf 1.2s linear infinite; }
@keyframes jbv2-spin-kf { to { transform: rotate(360deg); } }

/* Editor toolbar row (phase + save state + phase-jump) */
.jbv2-toolbar {
  display: flex; justify-content: space-between; align-items: center;
  gap: 12px; flex-wrap: wrap;
}

/* Placeholder card */
.jbv2-placeholder {
  padding: 24px;
  background: rgba(15,27,70,0.55);
  border: 1px dashed rgba(148,163,184,0.30);
  border-radius: 16px;
  color: #cbd5e1; font-size: 13.5px; line-height: 1.55;
}
.jbv2-placeholder h3 { margin: 0 0 6px; color: #f1f5f9; font-size: 15px; font-weight: 800; }
.jbv2-placeholder ul { margin: 8px 0 0 18px; }

/* Title input */
.jbv2-title-input {
  width: 100%;
  background: rgba(15,27,70,0.60); border: 1px solid rgba(148,163,184,0.24);
  border-radius: 12px; padding: 12px 14px;
  color: #f1f5f9; font-size: 16px; font-weight: 700; font-family: inherit;
}
.jbv2-title-input:focus { outline: none; border-color: rgba(103,232,249,0.55); background: rgba(15,27,70,0.85); }

/* ─── Phase B: Plan-phase section shell ─────────────────────────── */
.jbv2-section {
  padding: 16px 18px;
  background: rgba(15,27,70,0.65);
  border: 1px solid rgba(148,163,184,0.20);
  border-radius: 16px;
  display: flex; flex-direction: column; gap: 12px;
}
.jbv2-section-head {
  display: flex; align-items: center; gap: 10px; flex-wrap: wrap;
}
.jbv2-section-head-icon {
  width: 32px; height: 32px; border-radius: 10px;
  display: grid; place-items: center;
  color: var(--jb-c, #67e8f9);
  background: color-mix(in oklab, var(--jb-c, #67e8f9) 14%, transparent);
  border: 1px solid color-mix(in oklab, var(--jb-c, #67e8f9) 40%, transparent);
  flex-shrink: 0;
}
.jbv2-section-head-text { display: flex; flex-direction: column; gap: 2px; flex: 1; min-width: 220px; }
.jbv2-section-title    { margin: 0; font-size: 15px; font-weight: 800; color: #f1f5f9; }
.jbv2-section-sub      { font-size: 12px; color: #94a3b8; line-height: 1.4; }
.jbv2-section-badge {
  display: inline-flex; align-items: center; gap: 4px;
  padding: 3px 9px; border-radius: 999px;
  background: rgba(103,232,249,0.10);
  border: 1px solid rgba(103,232,249,0.32);
  color: #67e8f9; font-size: 10px; font-weight: 800;
  letter-spacing: 0.10em; text-transform: uppercase;
  white-space: nowrap;
}

/* Field grid & labels */
.jbv2-field-grid {
  display: grid; grid-template-columns: 1fr; gap: 10px;
}
@media (min-width: 720px) { .jbv2-field-grid { grid-template-columns: repeat(2, 1fr); } }
.jbv2-field { display: flex; flex-direction: column; gap: 4px; }
.jbv2-field--wide { grid-column: 1 / -1; }
.jbv2-field-label {
  font-size: 11px; font-weight: 800; letter-spacing: 0.10em;
  text-transform: uppercase; color: #94a3b8;
}
.jbv2-field-input, .jbv2-field-textarea, .jbv2-field-select {
  width: 100%;
  background: rgba(5,10,31,0.65); border: 1px solid rgba(148,163,184,0.24);
  border-radius: 10px; padding: 9px 11px;
  color: #f1f5f9; font-size: 14px; font-family: inherit;
}
.jbv2-field-textarea { min-height: 74px; resize: vertical; line-height: 1.5; }
.jbv2-field-input:focus, .jbv2-field-textarea:focus, .jbv2-field-select:focus {
  outline: none; border-color: rgba(103,232,249,0.55); background: rgba(5,10,31,0.9);
}
.jbv2-field-help { font-size: 11px; color: #94a3b8; }
.jbv2-field-check {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 8px 10px; border-radius: 10px;
  background: rgba(5,10,31,0.55); border: 1px solid rgba(148,163,184,0.20);
  color: #cbd5e1; font-size: 13px; cursor: pointer; font-family: inherit;
}
.jbv2-field-check input { accent-color: #67e8f9; }
.jbv2-field-check--on {
  border-color: rgba(103,232,249,0.55); background: rgba(103,232,249,0.10); color: #ecfeff;
}

/* Row / chip */
.jbv2-row {
  display: flex; align-items: center; gap: 10px;
  padding: 10px 12px;
  background: rgba(5,10,31,0.55);
  border: 1px solid rgba(148,163,184,0.20);
  border-radius: 10px;
  color: #f1f5f9; font-size: 13.5px;
}
.jbv2-row-body { flex: 1; min-width: 0; }
.jbv2-row-cat { color: #67e8f9; font-weight: 800; font-size: 12px; letter-spacing: 0.05em; }
.jbv2-row-note { color: #cbd5e1; font-size: 13px; line-height: 1.45; }
.jbv2-row-actions { display: flex; gap: 6px; flex-shrink: 0; }
.jbv2-row-btn {
  background: rgba(148,163,184,0.10); border: 1px solid rgba(148,163,184,0.24);
  color: #cbd5e1; border-radius: 8px; padding: 4px 8px;
  font-size: 11.5px; font-weight: 700; cursor: pointer; font-family: inherit;
}
.jbv2-row-btn:hover { background: rgba(148,163,184,0.22); color: #f1f5f9; }
.jbv2-row-btn--danger { color: #fca5a5; border-color: rgba(220,38,38,0.35); background: rgba(220,38,38,0.06); }
.jbv2-row-btn--danger:hover { background: rgba(220,38,38,0.14); }
.jbv2-row-btn--muted { color: #94a3b8; }
.jbv2-row--dismissed { opacity: 0.55; text-decoration: line-through; }
.jbv2-row--dismissed .jbv2-row-btn { text-decoration: none; }

/* Chip / suggestion row */
.jbv2-chips { display: flex; flex-wrap: wrap; gap: 6px; }
.jbv2-chip {
  display: inline-flex; align-items: center; gap: 4px;
  padding: 6px 10px; border-radius: 999px;
  background: rgba(15,27,70,0.55);
  border: 1px solid rgba(148,163,184,0.24);
  color: #cbd5e1; font-size: 12px; font-weight: 700; font-family: inherit;
  cursor: pointer;
}
.jbv2-chip:hover { background: rgba(15,27,70,0.85); color: #f1f5f9; border-color: rgba(103,232,249,0.45); }
.jbv2-chip--on {
  background: rgba(103,232,249,0.12); color: #ecfeff; border-color: rgba(103,232,249,0.55);
}
.jbv2-chip--danger {
  background: rgba(220,38,38,0.08); color: #fca5a5; border-color: rgba(220,38,38,0.40);
}

/* Inline add-row */
.jbv2-add-row {
  display: flex; gap: 8px; flex-wrap: wrap;
  padding: 10px 12px;
  background: rgba(5,10,31,0.40);
  border: 1px dashed rgba(148,163,184,0.28);
  border-radius: 12px;
}
.jbv2-add-row select, .jbv2-add-row input {
  flex: 1; min-width: 140px;
  background: rgba(5,10,31,0.70); border: 1px solid rgba(148,163,184,0.20);
  border-radius: 8px; padding: 7px 10px;
  color: #f1f5f9; font-size: 13px; font-family: inherit;
}
.jbv2-add-row button {
  background: rgba(103,232,249,0.12); border: 1px solid rgba(103,232,249,0.45);
  color: #ecfeff; border-radius: 8px; padding: 7px 12px;
  font-size: 13px; font-weight: 700; cursor: pointer; font-family: inherit;
}
.jbv2-add-row button:hover { background: rgba(103,232,249,0.22); }

/* Empty state inside a section */
.jbv2-empty {
  padding: 14px; border-radius: 10px;
  background: rgba(5,10,31,0.35);
  border: 1px dashed rgba(148,163,184,0.22);
  color: #94a3b8; font-size: 13px; text-align: center;
}

/* HP-tool row special styling */
.jbv2-hp-row { align-items: flex-start; flex-direction: column; gap: 6px; }
.jbv2-hp-row .jbv2-row-cat { color: #86efac; }
.jbv2-hp-row-meta { color: #94a3b8; font-size: 12px; }
.jbv2-hp-row-cite {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 2px 8px; border-radius: 6px;
  background: rgba(34,197,94,0.10);
  border: 1px solid rgba(34,197,94,0.35);
  color: #86efac; font-size: 11px; font-weight: 700;
}
.jbv2-hp-row-nosrc {
  padding: 2px 8px; border-radius: 6px;
  background: rgba(250,204,21,0.10);
  border: 1px solid rgba(250,204,21,0.40);
  color: #fef08a; font-size: 11px; font-weight: 700;
}
`;
